import React,{useState,useEffect} from 'react';
import Sidebar from '../components/Sidebar';
import Navbar from '../components/Navbar';
import HeroSection from '../components/HeroSection';
import TestiMonials from '../components/TestiMonials/index.js';
import Explore from '../components/Explore';
import RoomTypes from '../components/RoomTypes';
import Facilities from '../components/Facilities';
import Footer from '../components/Footer';
import Sroll from '../components/Scroll';
import {useSelector} from 'react-redux';
import Review from '../components/Review';
import ModalP from '../components/ModalP';
import BookingWidget from '../components/BookingWidget';




function Home() {
    const [isOpen,setIsOpen]= useState(false);
    const toggle= ()=>{
        setIsOpen(!isOpen);
    }
    const Hposts = useSelector((state)=>state.homePost);
    console.log(Hposts);

    

    return (
        <>
         <Sidebar isOpen={isOpen} toggle={toggle} />
         <Navbar toggle={toggle} /> 
         
         <HeroSection 
         contenu={Hposts}
          />
          <BookingWidget />
         <Explore  
         contenu={Hposts}
          /> 
         <RoomTypes  />
         <Facilities />
         <TestiMonials />
         <Review />
         
         <Sroll />
         <Footer />
        </>
    )
}

export default Home
